/* panel.tsx generated by @compiled/babel-plugin v0.37.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o51q7pw%7Banimation-fill-mode%3Aforwards%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y44vqhwn%7Banimation%3Avar(--ds-panel-exit%2C.2s%20cubic-bezier(.6%2C0%2C.8%2C.6)%20SlideOut100PercentRight)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o51eoah%7Banimation-fill-mode%3Abackwards%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y44v1s3l%7Banimation%3Avar(--ds-panel-enter%2C.25s%20cubic-bezier(0%2C.4%2C0%2C1)%20SlideIn100PercentRight)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0cglyw%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1osq%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m91wug%7Boverflow-y%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._1w6eia51%7Bborder-inline-start%3Avar(--ds-border-width%2C1px)%20solid%20var(--ds-border%2C%230b120e24)%7D._scbpglyw%7Bbox-shadow%3Anone%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16qs130s%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._191wglyw%7Bborder-inline-start%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A90rem)%7B._1dhy1c6w%7Bgrid-area%3Apanel%7D._9sns1wug%7Bz-index%3Aauto%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A64rem)%7B._4ap3vuon%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40media%20(min-width%3A48rem)%7B._14b54rrg%7Bwidth%3Avar(--n_pnlRsz%2Cvar(--n_pnlW))%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1dxx%7Bwidth%3Amin(90%25%2Cvar(--minWidth))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhk1bhr%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._152timx3%7Binset-block-start%3Acalc(var(--n_bnrM%2C%200px)%20%2B%20var(--n_tNvM%2C%200px))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqsw1if8%7Bposition%3Asticky%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3ieqxy%7Bheight%3Acalc(100vh%20-%20var(--n_bnrM%2C%200px)%20-%20var(--n_tNvM%2C%200px))%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbykb7n%7Bz-index%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._vchhusvi%7Bbox-sizing%3Aborder-box%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._10fph9n0%7Bjustify-self%3Aend%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._nd5l1b6c%7Bgrid-area%3Amain%2Faside%2Faside%2Faside%7D");
import { type CSSProperties, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { cx } from '@compiled/react';
import type { StrictXCSSProp } from '@atlaskit/css';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import { useMotion, Reanimate } from '@atlaskit/motion/use-motion';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- TODO: migrate to @atlaskit/primitives/compiled
import { media } from '@atlaskit/primitives/responsive';
import { useSkipLinkInternal } from '../../context/skip-links/use-skip-link-internal';
import { contentHeightWhenFixed, contentInsetBlockStart, localSlotLayers, panelPanelSplitterId, panelVar, sideNavLiveWidthVar, UNSAFE_panelLayoutVar } from './constants';
import { DangerouslyHoistCssVarToDocumentRoot } from './dangerously-hoist-css-var-to-document-root';
import { DangerouslyHoistSlotSizes } from './hoist-slot-sizes-context';
import { PanelSplitterProvider } from './panel-splitter/provider';
import type { ResizeBounds } from './panel-splitter/types';
import { useSideNavRef } from './side-nav/use-side-nav-ref';
import type { CommonSlotProps } from './types';
import { useLayoutId } from './use-layout-id';
import { useResizingWidthCssVarOnRootElement } from './use-resizing-width-css-var-on-root-element';
import { useSafeDefaultWidth } from './use-safe-default-width';
const panelSplitterResizingVar = '--n_pnlRsz';
const fallbackDefaultWidth = 365;

/**
 * We typically use the `defaultWidth` as the minimum resizing width,
 * but for large default widths we fallback to a standard value.
 *
 * This standard value of `400px` is to align with the Global Preview Panels.
 */
const fallbackResizeMinWidth = 400;
const styles = {
  root: "_nd5l1b6c _10fph9n0 _vchhusvi _1pbykb7n _4t3ieqxy _kqsw1if8 _152timx3 _bfhk1bhr _1bsb1dxx _14b54rrg _4ap3vuon _1dhy1c6w _9sns1wug",
  border: "_191wglyw _16qs130s _1w6eia51 _scbpglyw",
  scrollContainer: "_1reo1wug _18m91wug _4t3i1osq",
  hidden: "_1e0cglyw",
  entering: "_y44v1s3l _1o51eoah",
  exiting: "_y44vqhwn _1o51q7pw"
};

/**
 * The Panel layout area is rendered to the right (inline end) of the Main area, or the Aside area if it is present.
 *
 * On small viewports (below 64rem, or 1024px), the Panel slot will become an overlay.
 *
 * You can optionally render a `PanelSplitter` as a child to make the panel area resizable.
 */
export function Panel({
  children,
  defaultWidth: defaultWidthProp = fallbackDefaultWidth,
  label = 'Panel',
  skipLinkLabel = label,
  testId,
  id: providedId,
  xcss,
  hasBorder = true
}: CommonSlotProps & {
  /**
   * The content of the layout area.
   */
  children: React.ReactNode;
  /**
   * The accessible name of the slot, announced by screen readers.
   */
  label?: string;
  /**
   * The default width of the layout area.
   *
   * It should be an integer between the resize bounds - the minimum is 120px and the maximum is 50% of the viewport width.
   *
   * This value is also used as the minimum resizing width, except when the `defaultWidth` is greater then `400px`,
   * in which case `400px` will be used as the minimum resizing width instead.
   */
  defaultWidth?: number;
  /**
   * Bounded style overrides.
   */
  xcss?: StrictXCSSProp<'backgroundColor', never>;
  // We can clean up AFM usage
  // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required
  /**
   * Whether or not the slot has its own border. On small screens this becomes a shadow.
   *
   * Defaults to true. Will be removed in the future (and disabling the border will not be supported).
   *
   * @deprecated
   */
  hasBorder?: boolean;
}): JSX.Element {
  const dangerouslyHoistSlotSizes = useContext(DangerouslyHoistSlotSizes);
  const id = useLayoutId({
    providedId
  });

  // useMotion is applied only when the `platform-dst-motion-uplift-panel` gate is enabled.
  const {
    state,
    ref: motionRef,
    reanimate
  } = useMotion<HTMLElement>({
    onFinish: state => {
      if (state === 'exiting' && defaultWidthRef.current === 0) {
        // Set width to 0 as animation is complete
        setWidth(0);
      }
    }
  });
  const isMotionUpliftEnabled = fg('platform-dst-motion-uplift-panel');
  const defaultWidth = useSafeDefaultWidth({
    defaultWidthProp,
    fallbackDefaultWidth,
    slotName: 'Panel'
  });

  /**
   * Don't show the skip link if the slot has 0 width.
   *
   * Remove `isHidden` usage after https://jplat.atlassian.net/browse/BLU-3951
   *
   * TODO: when cleaning up 'platform_dst_nav4_skip_link_a11y_1' remove this call entirely
   */
  useSkipLinkInternal({
    id,
    label: skipLinkLabel,
    isHidden: defaultWidth === 0 || fg('platform_dst_nav4_skip_link_a11y_1')
  });
  const ref = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState(defaultWidth);
  // Used to track the previous value of the `defaultWidth` prop, for logging dev warnings when it changes.
  const defaultWidthRef = useRef(defaultWidth);

  // `mergeRefs` returns a new callback ref on every call, and combined with a new array literal
  // this would cause React to detach/re-attach the ref on every render. Memoise it so the merged
  // ref is stable across renders.
  const mergedRef = useMemo(() => isMotionUpliftEnabled ? mergeRefs([ref, motionRef]) : ref,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [isMotionUpliftEnabled, motionRef]);

  /**
   * TODO: Remove this useEffect once the `width: 0` usage is removed from Jira.
   * It updates the width state based on changes to `defaultWidth`, as a temporary stopgap to support Jira's current usage.
   * https://jplat.atlassian.net/browse/BLU-3951
   */
  useEffect(() => {
    if (defaultWidthRef.current === defaultWidth) {
      return;
    }
    if (isMotionUpliftEnabled) {
      if (defaultWidth === 0) {
        reanimate(Reanimate.exit);
        defaultWidthRef.current = defaultWidth;
        // Set width to 0 once the exit animation is complete
        return;
      } else if (defaultWidthRef.current === 0) {
        reanimate(Reanimate.enter);
      }
    }
    defaultWidthRef.current = defaultWidth;
    setWidth(defaultWidth);
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('Page Layout warning\n\n', 'The value of the `defaultWidth` prop on the `Panel` layout slot component has changed. This should not be changed after the component has been mounted.\n\n', 'In the future, changes to the `defaultWidth` prop will not be respected. It is only supported as a stopgap to enable migration from Nav3 to Nav4.\n\n');
    }
  }, [defaultWidth, isMotionUpliftEnabled, reanimate]);
  const sideNavRef = useSideNavRef();

  /**
   * The minimum width that the panel can be resized to by the user.
   *
   * We only use the `defaultWidth` up to a point to avoid huge panels.
   */
  const minWidth = Math.min(defaultWidth, fallbackResizeMinWidth);

  /**
   * Returns the bounds for resizing, evaluated lazily when needed.
   *
   * Defined separately to the slot bounds because the resizing bounds need to be resolvable to a pixel value,
   * and the panel's slot bounds use a complex CSS expression.
   */
  const getResizeBounds = useCallback((): ResizeBounds => {
    const sideNavWidth = sideNavRef.current?.offsetWidth ?? 0;
    /**
     * The panel should not resize larger than the page content, equivalent to the `Main` + `Aside` slots.
     *
     * This maximum width is equivalent to half the viewport width, after removing the sidebar width.
     */
    const maxWidth = Math.round((window.innerWidth - sideNavWidth) / 2);
    return {
      min: `${minWidth}px`,
      max: `${maxWidth}px`
    };
  }, [minWidth, sideNavRef]);
  const panelWidthSlotBounds = {
    min: `${minWidth}px`,
    // `sideNavLiveWidthVar` is not defined if the `SideNav` is not mounted, so we fallback to `0px`.
    max: `round(nearest, calc((100vw - var(${sideNavLiveWidthVar}, 0px)) / 2), 1px)`
  };
  const panelVariableWidth = `clamp(${panelWidthSlotBounds.min}, ${width}px, ${panelWidthSlotBounds.max})`;
  useResizingWidthCssVarOnRootElement({
    isEnabled: dangerouslyHoistSlotSizes,
    cssVar: panelSplitterResizingVar,
    panelId: panelPanelSplitterId
  });
  return <section id={id} data-layout-slot aria-label={label}
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  className={ax([styles.root, !isMotionUpliftEnabled && defaultWidth === 0 && styles.hidden, hasBorder && styles.border, isMotionUpliftEnabled ?
  // eslint-disable-next-line @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
  cx(xcss, state === 'entering' && styles.entering, state === 'exiting' && styles.exiting) : xcss])} style={({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
    [panelVar]: panelVariableWidth,
    '--minWidth': `${minWidth}px`
  } as CSSProperties)} data-testid={testId} ref={mergedRef}>
			{dangerouslyHoistSlotSizes &&
    // ------ START UNSAFE STYLES ------
    // These styles are only needed for the UNSAFE legacy use case for Jira + Confluence.
    // When they aren't needed anymore we can delete them wholesale.
    <DangerouslyHoistCssVarToDocumentRoot variableName={UNSAFE_panelLayoutVar} value="0px" mediaQuery={media.above.lg} responsiveValue={`var(${panelSplitterResizingVar}, ${panelVariableWidth})`} />
    // ------ END UNSAFE STYLES ------
    }
			<PanelSplitterProvider panelId={panelPanelSplitterId} panelRef={ref} panelWidth={width} onCompleteResize={setWidth} getResizeBounds={getResizeBounds} resizingCssVar={panelSplitterResizingVar} position="start">
				{/**
     * Overflow scroll styles are added here rather than on the `section` container element, so that the panel splitter
     * component can overflow out of the `Panel` container, to increase the interactive grab area
     */}
				<div className={ax([styles.scrollContainer])}>{children}</div>
			</PanelSplitterProvider>
		</section>;
}